export type FileValidationConfig = {
  maxBytes: number;
  allowedMimeTypes: string[];
  allowedExtensions: string[];
  label: string;
};

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
// Documents (Objekt Dokumente) allow larger marketing PDFs. Must stay in sync
// with the backend multer limit in services/aws_image_upload/storeImages.ts.
export const MAX_DOCUMENT_BYTES = 40 * 1024 * 1024;

export const IMAGE_ONLY: FileValidationConfig = {
  maxBytes: MAX_UPLOAD_BYTES,
  allowedMimeTypes: ["image/jpeg", "image/png", "image/webp", "image/bmp"],
  allowedExtensions: [".jpg", ".jpeg", ".png", ".webp", ".bmp"],
  label: "Bild (JPG, PNG, WEBP, BMP)",
};

export const IMAGE_OR_PDF: FileValidationConfig = {
  maxBytes: MAX_DOCUMENT_BYTES,
  allowedMimeTypes: ["image/jpeg", "image/png", "image/webp", "image/bmp", "application/pdf"],
  allowedExtensions: [".jpg", ".jpeg", ".png", ".webp", ".bmp", ".pdf"],
  label: "Bild oder PDF",
};

const formatMb = (bytes: number): string => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

const hasAllowedExtension = (name: string, allowed: string[]): boolean => {
  const lower = name.toLowerCase();
  return allowed.some((ext) => lower.endsWith(ext));
};

export type FileValidationResult = { valid: true } | { valid: false; error: string };

export const validateUploadFile = (
  file: File,
  config: FileValidationConfig,
): FileValidationResult => {
  if (file.size > config.maxBytes) {
    return {
      valid: false,
      error: `Die Datei ist zu groß (${formatMb(file.size)}). Maximal erlaubt: ${formatMb(config.maxBytes)}.`,
    };
  }

  const mimeOk = file.type && config.allowedMimeTypes.includes(file.type);
  const extOk = hasAllowedExtension(file.name, config.allowedExtensions);
  if (!mimeOk && !extOk) {
    return {
      valid: false,
      error: `Ungültiger Dateityp. Erlaubt: ${config.label}.`,
    };
  }

  return { valid: true };
};
